import { MapPin, Clock, Globe } from 'lucide-react'
import { getCountryFlag } from '@/lib/countries'
import { CollapsibleSection } from './CollapsibleSection'
import { InfoRow } from './InfoRow'
import { formatUrl } from './utils'

interface MainInfoSectionProps {
  locationDisplay: string
  countryCode: string | null
  localTime: string | null
  timezoneOffset: string | null
  referrer?: string | null
  expanded: boolean
  onToggle: () => void
}

export function MainInfoSection({ locationDisplay, countryCode, localTime, timezoneOffset, referrer, expanded, onToggle }: MainInfoSectionProps) {
  return (
    <CollapsibleSection title="Main information" expanded={expanded} onToggle={onToggle}>
      <div className="space-y-3">
        {locationDisplay && (
          <InfoRow icon={MapPin} label="Location">
            <span className="flex items-center gap-1.5">
              {getCountryFlag(countryCode) && <span>{getCountryFlag(countryCode)}</span>}
              {locationDisplay}
            </span>
          </InfoRow>
        )}
        {localTime && (
          <InfoRow icon={Clock} label="Local time">
            {localTime}
            {timezoneOffset && <span className="text-muted-foreground ml-1">({timezoneOffset})</span>}
          </InfoRow>
        )}
        {referrer && (
          <InfoRow icon={Globe} label="Referrer">
            <a href={referrer} target="_blank" rel="noopener noreferrer"
              className="text-primary hover:underline truncate max-w-[200px] inline-block cursor-pointer">
              {formatUrl(referrer)}
            </a>
          </InfoRow>
        )}
      </div>
    </CollapsibleSection>
  )
}
